import { render, staticRenderFns } from "./AdminDialog.vue?vue&type=template&id=bb4d2472"
import script from "./AdminDialog.vue?vue&type=script&lang=ts"
export * from "./AdminDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports